






























import validators from '@/validators';
import {RequestSession} from "@/interfaces/requestSession";
import {Donation} from "@/interfaces/donation/donation";
import donationSteps from "@/donationSteps";
import {Donor} from "@/interfaces/donation/donor";
import Vue from 'vue';
import {DonationCause} from "@/interfaces/organizationgroup/donationCause";
import { isMemoryGift } from '@/classes/DonationType';

export default Vue.extend({
  components: {
  },
  props: {
    value: {
      type: Object as () => Donor,
    },
    form: Object
  },
  data() {
    return {
      showCause: false,
      rules: {},
    };
  },
  computed: {
    donationDetails: {
      get():Donation {
        return this.value
      },
      set(val:Donation) {
        this.$emit('update:value', val)
      }
    },
    requestSession(): RequestSession {
      return this.$store.state.requestSession
    },
    donation(): Donation {
      return this.$store.state.donation
    },
    currentStep() {
      return this.$store.state.currentStep
    },
    activeDonationCauses() {
      return this.requestSession.organizationGroup.donationCauses.filter((donationCause: DonationCause) => {return donationCause.active})
    }
  },
  watch: {
    currentStep(newVal, oldVal) {
      if (newVal == donationSteps.step.DONATION_DETAILS) {
        this.calculateShowCause()
        // TODO - handle if we have more than one OrganizationGroup
        if(!this.showCause)
        {
          // if there is only one cause we skip this step
          this.handleStepRemoval(oldVal)
        }
      }
      else if(!isMemoryGift(this.donation.donationType.type)) {
        this.$emit('addStep', donationSteps.step.DONATION_DETAILS)
      }
    }
  },
  created() {
    // NOTE: This might be an issue if language is to be changed runtime
    Object.assign(this.rules, validators(this.$t('validation')));
  },
  methods: {
    calculateShowCause() {
      // TODO - must be handled different if we don't have an OrganizationGroup in our requestSession
      if (this.activeDonationCauses && this.activeDonationCauses.length === 1
      ) {
        this.showCause = false;
        this.donationDetails.donationCause = this.activeDonationCauses[0];
      } else {
        this.showCause = true;
      }
    },
    handleStepRemoval(oldVal) {
      this.$emit('removeStep', donationSteps.step.DONATION_DETAILS)
      if (oldVal === donationSteps.step.DONATION_DETAILS + 1) {
        this.$emit('previousStep')
      } else {
        this.$emit('nextStep')
      }
    },
    t(label) {
      const $te = this.$te.bind(this);
      const $t = this.$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
  },
});
